module.exports = __webpack_public_path__ + "img/instruction-cocoa2-android-01.71b7a747.png";